module.exports = __webpack_public_path__ + "img/019-seaman.82adb977.png";